module.exports = __webpack_public_path__ + "static/media/WhatsApp.a4ab4c6a.svg";